import React, { Fragment, useState, useEffect, useContext } from "react";
import { Col, Container, Row } from "reactstrap";
import CustomerDetails from "../CustomerDetails";
import TripDetails from "./TripDetails";
import DetailsMap from "../DetailsMap";
import AddNewButton from "../../Common/Component/AddNewButton";
import { useNavigate, useParams } from "react-router-dom";
import { FileText } from "react-feather";
import EditBookCab from "../BookingHistory/EditBookCab";
import DriverInformation from "../DriverInformation";
import {
  getInvoice,
  getTripDetails,
  getTripRoutePoints,
} from "../../../Services/Trip.service";
import {
  getBookingById
} from "../../../Services/Booking.service";
import { getCustomerDetails } from "../../../Services/Customer.service";
import SharedDataContext from "../../../_helper/SharedData";
import { getUserRole, showAlert } from "../../../Services/Shared.service";
import { Admin, Capture, Dispatch, ShiftInCharge, VendorAgent } from "../../../Data/SideMenu/RouteMapping";
import { assignDriverValidStatus } from "../../../Data/Booking/BookingHistory";
import BookingContext from "../../../_helper/Booking";
import { getDriverDataByBookingNumber } from "../../../Services/Driver.service";
import BookingDetails from "../BookingInfo/BookingDetails";
import BookEdit from "../BookingHistory/bookEdit";
const TripInfo = () => {
  const userRole = getUserRole();
  const {
    setShowApiLoader,
    cityData,
    airportData,
  } = useContext(SharedDataContext);
  const { emptyCallback } = useContext(BookingContext);
  const [bookingModal, setBookingModal] = useState(false);
  const BookingModalToggle = () => setBookingModal(!bookingModal);
  const [ticketModal, setticketModal] = useState(false);
  const TicketModalToggle = () => setticketModal(!ticketModal);
  const { tripId } = useParams();
  const [tripObj, setTripObj] = useState({});
  const [bookingObj, setBookingObj] = useState({});
  const [mapRoute, setMapRoute] = useState([]);

  const [bookingList, setBookingList] = useState(userRole.some((element)=> element !== VendorAgent) ? "trip_details" : "booking_details");
  const history = useNavigate();
  const redirectTimeLogPage = () => {
    history(
      `${process.env.PUBLIC_URL}/booking/booking-info/time-log/${tripObj?.megaCabsBookingNo}`
    );
  };

  const showInvoice = () => {
    getInvoice(tripObj);
  };

  const [driverDetails, setDriverDetails] = useState({});
  const [customerDetails, setCustomerDetails] = useState({});
  const [latLng, setLatLng] = useState({});
  useEffect(() => {
    setShowApiLoader(true);
    getTripDetails(tripId)
      .then((tripRes) => {
        console.log(tripRes.data, "tripresult");
        const tripData = tripRes.data;
        if (tripData) {
          setTripObj(tripData);
          if (tripData?.bookingId) {
            getBookingById(tripData.bookingId).then((bookingRes) => {
              if (bookingRes.data) {
                setBookingObj(bookingRes.data);
              }
            });
          }
          if (tripData?.customerId) {
            getCustomerDetails(tripData.customerId)
              .then((customerResult) => {
                setShowApiLoader(false);
                console.log(customerResult, "customerResult");
                setCustomerDetails(customerResult.data);
              })
              .catch((err) => {
                setShowApiLoader(false);
                showAlert("error", "Something went wrong");
              });
          } else {
            setShowApiLoader(false);
          }
          if (tripData?.megaCabsBookingNo) {
            getDriverDataByBookingNumber(tripData.megaCabsBookingNo).then((driverResult) => {
              if (driverResult.data) {
                const obj = {
                  fullName: driverResult.data?.fullName,
                  mobile: driverResult.data?.mobile,
                  megacabsRating: driverResult.data?.megacabsRating,
                  mainCabNo: tripData?.carNo,
                  carType: tripData?.carType,
                  isPrimaryDriver: driverResult.data?.isPrimaryDriver
                };
                setDriverDetails(obj);
              }
            });
          }
          if (tripData?.driverId && tripData?.carNo) {
            let obj = {
              driverId: tripData.driverId,
              carNo: tripData.carNo,
              tripId,
            };
            getTripRoutePoints(obj).then((routeData) => {
              if (routeData.data) {
                setMapRoute(routeData.data);
              }
            });
          }
        }
      })
      .catch((err) => {
        showAlert("error", "Something went wrong");
      });
  }, []);
  return (
    <Fragment>
      <Container fluid={true}>
        <Row>
          <Col xs="12">
            <Row>
              <Col xl="4">
                <CustomerDetails
                  customerDetails={customerDetails}
                  tripObj={tripObj}
                />
              </Col>
              <Col xl="8">
                <DetailsMap bookingObj={tripObj} mapRoute={mapRoute} />
              </Col>
            </Row>
          </Col>
          <Col md="12">
            <Row className="trip-options">
              <div>
                <ul className="booking-tabs">
                  {
                    userRole.some((element) => element !== VendorAgent ) ? 
                      <li
                        className={`${
                          bookingList == "trip_details" ? "active" : ""
                        }`}
                        onClick={() => setBookingList("trip_details")}
                      >
                        Trip Details
                        <div className="arrow-down"></div>
                      </li> 
                    : ""
                  }
                  <li
                    className={`${
                      bookingList == "booking_details" ? "active" : ""
                    }`}
                    onClick={() => setBookingList("booking_details")}
                  >
                    Booking Details
                    <div className="arrow-down"></div>
                  </li>
                  <li
                    className={`${
                      bookingList == "driver_information" ? "active" : ""
                    }`}
                    onClick={() => setBookingList("driver_information")}
                  >
                    Driver Information
                    <div className="arrow-down"></div>
                  </li>
                </ul>
              </div>
              <div className="more-options">
                <div>
                  {userRole.some(
                    (element) => element == Dispatch || element == Admin
                  ) &&
                  tripObj &&
                  assignDriverValidStatus.includes(
                    tripObj?.currentTripStatusType
                  ) ? (
                    <AddNewButton
                      options={{
                        name: tripObj.driverId
                          ? "Reassign Driver"
                          : "Assign Driver",
                        icon: <i className="fa fa-user-plus"></i>,
                        title: "Assign Driver",
                      }}
                    ></AddNewButton>
                  ) : (
                    ""
                  )}
                  {tripObj?.currentTripStatusType == "Complete" && userRole.some((element) => element !== VendorAgent) ? (
                    <AddNewButton
                      options={{
                        name: "Invoice",
                        icon: <FileText />,
                        title: "Invoice",
                        onclickEvent: showInvoice,
                      }}
                    ></AddNewButton>
                  ) : (
                    ""
                  )}
                </div>
                <div>
                  {userRole.some(
                    (element) =>
                      element == Capture ||
                      element == Admin ||
                      element == ShiftInCharge
                  ) ? (
                    <AddNewButton
                      options={{
                        name: "Re-book",
                        icon: <i className="fa fa-car"></i>,
                        onclickEvent: BookingModalToggle,
                      }}
                    >
                      {/* <EditBookCab
                        title={"Re-book"}
                        Large={bookingModal}
                        LargeModaltoggle={BookingModalToggle}
                        cityData={cityData}
                        airportData={airportData}
                        onSubmitData={{ fetchBookingData: emptyCallback }}
                        editType={"Rebook"}
                        bookingData={bookingObj}
                        setShowApiLoader={setShowApiLoader}
                      /> */}
                      <BookEdit
                        LargeModaltoggle={BookingModalToggle}
                        title={"Create a new booking"}
                        Large={bookingModal}
                        bookingData={bookingObj}
                        cityData={cityData}
                        airportData={airportData}
                        onSubmitData={{ fetchBookingData: emptyCallback }}
                        editType={"Rebook"}
                        setShowApiLoader={setShowApiLoader}
                      />
                    </AddNewButton>
                  ) : (
                    ""
                  )}
                </div>
                <div>
                  <AddNewButton
                    options={{
                      name: "Time log",
                      icon: <i className="fa fa-clock-o"></i>,
                      title: "Time log",
                      onclickEvent: redirectTimeLogPage,
                    }}
                  ></AddNewButton>
                </div>
                <div></div>
              </div>
            </Row>

            {bookingList == "trip_details" ? (
              <TripDetails tripObj={tripObj} bookingObj={bookingObj} />
            ) : bookingList == "booking_details" ? (
              <BookingDetails bookingObj={bookingObj} />
            ) : (
              <DriverInformation driverDetails={driverDetails} />
            )}
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
export default TripInfo;
